import template from './default.html';
import controller from './default.controller';
import './default.scss';

let defaultComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default defaultComponent;



// WEBPACK FOOTER //
// ./client/app/pages/default/default.component.js